import { FC } from 'react';
import parse from 'html-react-parser';
import styles from './index.module.scss';

/** リンクリスト*/
interface Props {
  /** html */
  html: string;
}
/**
 * リンクリスト
 */
export const ConditionLinkList: FC<Props> = ({ html }) => {
  return <div className={styles.conditionLinkList}>{parse(html)}</div>;
};
